<script setup>
import {mdiCheckBold, mdiCloseThick} from "@mdi/js";
import SelectionButtonsInput from "@/components/forms/SelectionButtonsInput.vue";
import SelectionButton from "@/components/forms/SelectionButton.vue";
import {YesNo, YesNoLabels} from "@/choices";

const ventilated = defineModel({type: Boolean});
const props = defineProps({
    fieldProps: {
        type: Object,
    },
});
const emit = defineEmits(['submit']);

function submit() {
    emit('submit', ventilated.value);
}
</script>

<template>
    <main>
        <h1>{{ pgettext('label', 'ALS') }}</h1>

        <SelectionButtonsInput v-model="ventilated" v-bind="fieldProps" size="x-large" :height="72" @select="submit()">
            <SelectionButton :value="YesNo.YES" color="green-darken-1" :prepend-icon="mdiCheckBold">
                <strong>{{ YesNoLabels[YesNo.YES] }}</strong>
            </SelectionButton>
            <SelectionButton :value="YesNo.NO" color="red-darken-1" :prepend-icon="mdiCloseThick">
                <strong>{{ YesNoLabels[YesNo.NO] }}</strong>
            </SelectionButton>
        </SelectionButtonsInput>

        <p v-if="ventilated != null" class="text-center mt-4">
            <v-btn color="green" size="large" @click="submit()">
                <strong>{{ pgettext('action', 'Continue') }}</strong>
            </v-btn>
        </p>
        <p v-else class="text-center text-subtitle-2">
            {{ gettext('To continue, please select one of the options.') }}
        </p>
    </main>
</template>
